import {Resolve, RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Grupa} from './grupa';
import {KursanciService} from './kursanci.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class GrupaResolver implements Resolve<Grupa> {

    constructor(private kursanciService: KursanciService) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<Grupa> {

        return this.kursanciService.findGrupaByKey(route.params['key'])
            .snapshotChanges().map(action => {
                const data = action.payload.val() as Grupa;
                const key = action.payload.key;
                return { key, ...data };
              })
              .first()
              // .do( res => console.log('Resolver:', res))
      }
  }


// WEBPACK FOOTER //
// ./src/app/services/grupa.resolver.ts